// Fix for dropdown menu positioning when using keyboard navigation
document.addEventListener('DOMContentLoaded', function() {
  // Add CSS rule for keyboard-focused dropdowns in secondary and tertiary navigation
  var style = document.createElement('style');
  style.innerHTML = `
    .site-navigation--secondary .menu--main-item.keyboard-focus .menu--dropdown {
      margin-top: -5px !important;
    }
    .site-navigation--tertiary .menu--main-item.keyboard-focus .menu--dropdown {
      margin-top: -5px !important;
    }
  `;
  document.head.appendChild(style);
  
  // Dynamic positioning for tertiary navigation dropdown
  function setTertiaryDropdownPosition() {
    const tertiaryNav = document.querySelector('.site-navigation--tertiary');
    if (!tertiaryNav) return;
    
    // Remove any previous dropdown style to avoid duplicates
    const existingStyle = document.getElementById('dropdown-position-style');
    if (existingStyle) {
      existingStyle.remove();
    }
    
    // Get the navigation's bottom position relative to the viewport
    const navRect = tertiaryNav.getBoundingClientRect();
    const navBottom = navRect.bottom;
    
    // Create a style rule to set the dropdown top position dynamically based on current nav position
    const dropdownStyle = document.createElement('style');
    dropdownStyle.id = 'dropdown-position-style';
    dropdownStyle.innerHTML = `
      .site-navigation--tertiary .menu--dropdown {
        position: fixed;
        top: ${navBottom}px !important;
      }
    `;
    document.head.appendChild(dropdownStyle);
  }
  
  // Call the function initially
  setTertiaryDropdownPosition();
  
  // Update on window resize
  window.addEventListener('resize', setTertiaryDropdownPosition);
  
  // Update on scroll
  window.addEventListener('scroll', setTertiaryDropdownPosition);
});
